export const environment = {
    production: true,
    GSBearer: 'acf7def1-9f79-466b-a0b3-bb6469b8ca33',
    serviceBaseUrl: 'https://apigw.etfr.eurofins.com/demetrauat/server/',
    GSServiceBaseUrl: 'https://apigw.etfr.eurofins.com/gsuat/server/',
    launcherUrl: 'https://launcheruat.etfr.eurofins.com/',
    appCode: 'APP0000020',
    appName: 'Demetra UAT',
    name: 'UAT'
  };
  